
export const USER = 0;
export const USER_VIEW_ALL = 1;
export const ADMIN_BROKER = 2;
//    export const USER_VIEW_ONLY = 3;
export const USER_RESEARCH_ONLY = 4;
export const PRIMARY_ADMIN = 5;
export const PROJECT_ADMIN = 6;

export const PRIMARY_ADMIN_LABEL = 'Primary Admin';
export const ADMIN_BROKER_LABEL = 'Admin';
export const USER_LABEL = 'User';
//    export const USER_VIEW_ONLY = 'User (view only)';
export const USER_VIEW_ALL_LABEL = 'User (view all)';
export const USER_RESEARCH_ONLY_LABEL = 'Research Only';
export const PROJECT_ADMIN_LABEL = 'Project Admin';